export const DROPDOWN_TYPES = {
  ActivitiesType: 'activitiesType',
  StoreSelector: 'storeSelector',
  Actions: 'actions',
  Schedule: 'schedule',
  SalesTargetType: 'salesTargetType',
  PointMultiplierRulesCriteria: 'rulesCriteria',
  PointMultiplierSegment: 'segment',
  PointMultiplierCategory: 'category',
  PointMultiplierChannel: 'channel'
}